module.exports = __webpack_public_path__ + "static/media/Item_Weapon_C4_C.953fb9e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Throwable/Item_Weapon_C4_C.png
// module id = 255
// module chunks = 0